import { RefinedDataItem } from "@/lib/useQuery/useGetExportData";
import { ParserMap } from ".";

export const createFieldParser = (parsersMap: ParserMap) => {
    return (item: RefinedDataItem): RefinedDataItem => {
      try {
        const fieldType = item["Field Type"].value;
        if (!fieldType) return item;
        
        const parser = parsersMap[fieldType];
        
        if (!parser) return item;
        
        const parsedValue = parser(item.Values.value, item);
        
        return {
          ...item,
          Values: {
            ...item.Values,
            value: parsedValue
          }
        };
      } catch (e) {
        console.error("Error parsing field:", item, e);
        return item;
      }
    };
  };